import { FormFields } from 'hooks';
import { validateCreditCardNumber } from '@utils/validateCreditCardNumber';
import { expiryDateValidator } from '@utils/expiryDateValidator';
import { validateCVC } from '@utils/validateCVC';

export type PaymentFormFieldNames = 'cardNumber' | 'expiryDate' | 'cvc';

export const formFields: FormFields<PaymentFormFieldNames> = {
  cardNumber: {
    name: 'cardNumber',
    initialValue: '',
    isRequired: true,
    validate: validateCreditCardNumber,
    requiredMessage: 'Credit Card number is required'
  },
  expiryDate: {
    name: 'expiryDate',
    initialValue: '',
    isRequired: true,
    validate: expiryDateValidator,
    requiredMessage: 'Expiry date is required'
  },
  cvc: {
    name: 'cvc',
    initialValue: '',
    isRequired: true,
    validate: validateCVC,
    requiredMessage: 'CVC Code is required'
  }
};
